import { createContext } from 'react';
import { Context } from './types';

export const PlanMapDisplayContext =
    createContext<Context | undefined>(undefined);
